import styles from './styles.less';
import { observer } from 'mobx-react';


const FeaturedShows = (props) => props.shows.length > 0 ? (
    <div className={ cx(styles.root, props.className) }>
        <h3 className={ styles.heading }><img src={ props.headerImage } alt={ props. headerTitle } /></h3>
        <ul className={ styles.list }>
            { props.shows.map(show => (
            <li className={ styles.show }>
                <a className={ styles.showLink } href={ show.url }>
                    <img className={ styles.showImage } src={ show.image } alt={ show.callout } />
                    <h4 className={ styles.showCallout }>{ show.callout }</h4>
                </a>
            </li>
            ))}
        </ul>
    </div>
) : null;

FeaturedShows.propTypes = {
    headerImage: React.PropTypes.string.isRequired,
    headerTitle: React.PropTypes.string.isRequired,
    shows: React.PropTypes.array.isRequired
};

FeaturedShows.defaultProps = {
    headerImage: 'http://i.cdn.turner.com/adultswim/big/img/show-index/featured-shows.png',
    headerTitle: 'Featured Shows'
};


export default observer(FeaturedShows);



// WEBPACK FOOTER //
// ./src/show-index/components/featured-shows/index.js